// extracted by mini-css-extract-plugin
export default {"header":"NotificationList_header__oNcI2"};